export default __webpack_public_path__ + "static/media/logo_service_weather.3e40fd94.svg";